import { useContext } from 'react';

import {
  EntitlementsContext,
  type EntitlementsContextType,
} from './entitlementsContextValue';

export const useEntitlements = (): EntitlementsContextType => {
  const context = useContext(EntitlementsContext);

  if (!context) {
    throw new Error(
      'useEntitlements must be used within an EntitlementsProvider',
    );
  }
  return context;
};
